interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

export function LoadingSpinner({ size = 'md', className = '' }: LoadingSpinnerProps) {
  const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-8 h-8',
    lg: 'w-12 h-12',
  };

  return (
    <div className={`flex items-center justify-center ${className}`}>
      <div
        className={`${sizeClasses[size]} border-2 border-surface-400 border-t-primary-500 rounded-full animate-spin`}
      />
    </div>
  );
}

interface LoadingPageProps {
  message?: string;
}

export function LoadingPage({ message = 'Loading...' }: LoadingPageProps) {
  return (
    <div className="flex flex-col items-center justify-center min-h-[400px] gap-4">
      <LoadingSpinner size="lg" />
      <p className="text-text-secondary text-sm">{message}</p>
    </div>
  );
}

interface LoadingSkeletonProps {
  className?: string;
}

export function LoadingSkeleton({ className = 'h-4 w-full' }: LoadingSkeletonProps) {
  return (
    <div className={`bg-surface-600 rounded animate-pulse ${className}`} />
  );
}

export function LoadingCard() {
  return (
    <div className="card p-4 space-y-3">
      <LoadingSkeleton className="h-3 w-24" />
      <LoadingSkeleton className="h-8 w-32" />
    </div>
  );
}
